import { CircularProgress } from '@mui/material';

const Loader = () => {
  return (
    <div className="flex flex-col justify-center items-center w-full h-full">
      <CircularProgress color="primary" />
    </div>
  );
};

export default Loader;
